import { reactive } from 'vue';

export const dialogState = reactive({ show: false, title: '', message: '', kind: 'notice', tone: 'info', value: '' });
const queue = [];
let active;
function next() {
  if (active || !queue.length) return;
  active = queue.shift();
  Object.assign(dialogState, { title: 'แจ้งเตือน', message: '', kind: 'notice', tone: 'info', value: '', confirmText: 'ยืนยัน' }, active.options, { show: true });
}
function open(options) { return new Promise(resolve => { queue.push({ options, resolve }); next(); }); }
export function finishDialog(accepted) {
  if (!active) return;
  const current = active;
  dialogState.show = false;
  current.resolve(dialogState.kind === 'prompt' ? (accepted ? dialogState.value.trim() : null) : accepted);
  // Finish the leave transition before showing the next queued dialog.
  setTimeout(() => { active = null; next(); }, 200);
}
export const notify = (message, tone = 'info') => open({ title: tone === 'error' ? 'ดำเนินการไม่สำเร็จ' : tone === 'success' ? 'เรียบร้อยแล้ว' : 'แจ้งเตือน', message, tone });
export const confirmAction = (message, options = {}) => open({ title: 'ยืนยันดำเนินการ', message, kind: 'confirm', ...options });
export const promptValue = (title, value = '') => open({ title, value, kind: 'prompt' });
